import './styles.css';

export type SocialLinkProps = {
	url: string;
	icon: string;
	padded?: boolean;
};

export const SocialLink: React.FC<SocialLinkProps> = ({
	url,
	icon,
	padded = false
}) => (
	<li className={`social-link${padded ? ' social-link-padded' : ''}`}>
		<a
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			style={{ width: '32px', height: '32px' }}
		>
			<img
				src={icon}
				style={{ width: '28px', height: '28px', borderRadius: '50%' }}
			/>
		</a>
	</li>
);
